<template>
  <div>
    <Header/>
    <div v-if="Object.keys(laptop).length">
      <div class="container">
        <h1 class="title">
          {{ laptop.brand.name }}
          {{ laptop.name }}
          <span v-if="laptop.awaiting === true" class="title is-5">[Под Заказ: Срок доставки 1-2 недели]</span>
        </h1>
        <div class="columns">
          <div class="column is-5">
            <div class="images clearfix">
              <viewer :images="laptop.images" :movable="true">
                <img v-for="src in laptop.images" :key="src.url" :src="MEDIA_URL + src.url" class="image">
              </viewer>
            </div>
          </div>
          <div class="column">
            <aside class="menu">
              <div class="columns">
                <div class="column">
                  <p class="menu-label">
                    Коротко о ноутбуке:
                  </p>
                  <ul class="menu-list">
                    <li><a><span class="is-black has-text-weight-light">Состояние:</span> Новый</a></li>
                    <li>
                      <router-link :to="'/' + laptop.brand.slug+ '-noutbuki'"><span
                          class="">Производитель:</span> {{
                          laptop.brand.name
                        }}
                      </router-link>
                    </li>
                    <li>
                      <router-link :to="'/search/' + laptop.processor.name">Процессор:
                        {{ processor_type }} {{ laptop.processor.brand.name }} {{ laptop.processor.name }}
                      </router-link>
                    </li>
                    <li><a>Частота процессора: {{ laptop.processor.min_frequency }} -
                      {{ laptop.processor.max_frequency }} ГГц</a></li>
                    <li><a>Оперативная память: {{ laptop.ram }} ГБ {{ laptop.ram_type.generation }}</a></li>
                    <li><a>Общий объем накопителя: {{
                        laptop.main_storage +
                        laptop.secondary_storage
                      }}
                      ГБ</a></li>
                    <li>
                      <router-link :to="'/search/' + laptop.screen_size.size">Диагональ экрана:
                        {{ laptop.screen_size.size }}"
                      </router-link>
                    </li>
                    <li>
                      <router-link :to="'/search/' + laptop.resolution.size">Разрешение: {{ laptop.resolution.size }} {{
                          laptop.resolution.name
                        }}
                      </router-link>
                    </li>
                    <li>
                      <a v-if="laptop.graphics_card">
                        Видеокарта: {{ laptop.graphics_card.brand.name }} {{ laptop.graphics_card.name }}
                        ({{ laptop.graphics_card_memory }} ГБ {{ laptop.graphics_card.memory_interface }} /
                        {{ laptop.graphics_card.memory_interface_width }} бит)
                      </a>
                      <a v-else-if="laptop.processor.integrated_graphics">
                        Видеокарта: {{ laptop.processor.integrated_graphics }}
                      </a>
                      <a v-else>
                        Видеокарта: Встроенная
                      </a>
                    </li>

                    <li v-if="laptop.perks.length">
                      <a>Фишки:</a>
                      <span class="tag" v-for="perk in laptop.perks" :key="perk.id">
                          <router-link :to="'/search/' + perk.name">
                            {{ perk.name }}
                            </router-link><br/>
                      </span>
                    </li>
                    <li><a><span class="is-size-7">Краткое описание:</span><br/>{{ laptop.short_description }}</a></li>
                    <li><a>Цена:<br/>
                      <span class="tag is-black is-size-7"><strong>{{
                          formatPrice(laptop.price_month)
                        }}$</strong></span>
                      (<strong>{{ formatPrice(laptop.price_month_uzs) }}</strong> сум) с гарантией на <strong>1
                        месяц</strong><br/>
                      <span class="tag is-black is-size-7"><strong>{{ formatPrice(laptop.price_year) }}$</strong></span>
                      (<strong>{{ formatPrice(laptop.price_year_uzs) }}</strong> сум) с гарантией на <strong>1
                        год</strong>
                    </a>
                    </li>
                  </ul>
                </div>
                <div class="column is-one-third">
                  <p class="menu-label">
                    Методы Оплаты:
                  </p>
                  <p>
                    <b-icon pack="fas" icon="check" size="is-small" type="is-success"></b-icon>
                    <span> Наличными</span>
                  </p>
                  <p>
                    <b-icon pack="fas" icon="check" size="is-small" type="is-success"></b-icon>
                    <span> Payme / Click</span>
                  </p>
                  <p>
                    <b-icon pack="fas" icon="check" size="is-small" type="is-success"></b-icon>
                    <span> При Доставке</span>
                  </p>
                  <br/>
                  <div v-if="laptop.active">
                    <p>
                      <b-icon pack="fas" icon="check" size="is-small" type="is-success"></b-icon>
                      <span> Есть в наличии</span>
                    </p>
                    <p>
                      <button v-if="!ordered"
                              class="button is-success is-large has-text-weight-semibold"
                              @click="isOrderModalActive = true">
                        Хочу Купить
                      </button>
                    </p>
                  </div>
                  <div v-else>
                    <p>
                      <b-icon pack="fas" icon="times" size="is-small" type="is-danger"></b-icon>
                      <span class="has-text-danger"> Временно нет в наличии</span>
                    </p>
                    <p>
                      <button v-if="!ordered"
                              class="button is-success is-large has-text-weight-semibold"
                              @click="isOrderModalActive = true">
                        Хочу на заказ
                      </button>
                    </p>
                  </div>
                  Есть вопросы?<br/>
                  <a class="navbar-item" :href="'tel:'+contacts.phone_number">
                    <img src="../../../assets/images/social/phone.png" width="16">
                    <span class=" has-text-weight-bold">&nbsp; {{ contacts.phone_number }}</span>
                  </a>
                  <a class="navbar-item" :href="'https://telegram.me/'+contacts.telegram_username" target="_blank">
                    <img src="../../../assets/images/social/telegram.png" width="16">
                    <span class=" has-text-weight-bold">&nbsp; @{{ contacts.telegram_username }}</span>
                  </a>
                  <!--                  <p>-->
                  <!--                    <img src="../../../assets/images/free_delivery.png" width="322" height="98"/>-->
                  <!--                  </p>-->
                </div>
              </div>
              <b-modal
                  :active.sync="isOrderModalActive"
                  :width="640"
                  scroll="keep"
              >
                <div class="card">
                  <div class="card-content">
                    <div class="content">
                      <div @keyup.13="postInquiry" class="has-text-warning">
                        <h1 class="subtitle">Заполните эту простую форму и мы свяжемся с вами в течении 10 минут для
                          обсуждения деталей.</h1>

                        <b-field label="Ваше Имя" type="is-success">
                          <b-input placeholder="Введите ваше имя сюда"
                                   v-model="personal_data.name"
                                   ref="name"
                                   autofocus></b-input>
                        </b-field>
                        <b-field grouped>
                          <b-field label="Номер для связи" type="is-success" expanded>
                            <b-input type="number" v-model="personal_data.phone"
                                     placeholder="К примеру: 90 911 22 44"></b-input>
                          </b-field>
                        </b-field>
                        <button class="button is-success is-pulled-right" @click="postInquiry">Отправить
                          заявку
                        </button>
                        <button class="button is-danger is-inverted is-pulled-right"
                                @click="isOrderModalActive = false">Отменить
                        </button>
                        &nbsp;
                      </div>
                    </div>
                  </div>
                </div>
              </b-modal>
            </aside>
          </div>
        </div>
      </div>
      <div class="separator"></div>
      <section class="section">
        <div class="container">
          <h1 v-if="laptop.model" class="title has-text-centered">
            Подробная характеристика ноутбука
            {{ laptop.brand.name }}
            {{ laptop.name }}
            ({{ laptop.model }})
          </h1>
          <h1 v-else class="title has-text-centered">
            Подробная характеристика ноутбука
            {{ laptop.brand.name }}
            {{ laptop.name }}
          </h1>
          <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
            <thead>
            <tr>
              <th colspan="2"><abbr title="Position">Информация о моделе</abbr></th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>Производитель</td>
              <td>
                <router-link :to="'/' + laptop.brand.slug+ '-noutbuki'">{{ laptop.brand.name }}</router-link>
              </td>
            </tr>
            <tr>
              <td>Марка Ноутбука</td>
              <td>{{ laptop.name }}</td>
            </tr>
            <tr>
              <td>Модель</td>
              <td>{{ laptop.part_number }}</td>
            </tr>
            <tr>
              <td>Tип</td>
              <td>
                <router-link :to="'/' + type.slug" v-for="type in laptop.laptop_type" :key="type.id">{{ type.name_singular }} |
                </router-link>
              </td>
            </tr>
            </tbody>
            <thead>
            <tr>
              <th colspan="2"><abbr title="Position">Дисплей</abbr></th>
              <th><abbr title="Position"></abbr></th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>Диагональ экрана</td>
              <td>{{ laptop.screen_size.size }}"</td>
            </tr>
            <tr>
              <td rowspan="2">Разрешение</td>
              <td>{{ laptop.resolution.size }} пикселей</td>
            </tr>
            <tr>
              <td>{{ laptop.resolution.name }}</td>
            </tr>
            </tbody>
            <thead>
            <tr>
              <th colspan="2"><abbr title="Position">Процессор</abbr></th>
              <th><abbr title="Position"></abbr></th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>Марка</td>
              <td>{{ laptop.processor.brand.name }}</td>
            </tr>
            <tr>
              <td>Модель</td>
              <td>{{ laptop.processor.name }}</td>
            </tr>
            <tr>
              <td>Минимальная частота</td>
              <td>{{ laptop.processor.min_frequency }} ГГц</td>
            </tr>
            <tr>
              <td>Максимальная частота</td>
              <td>{{ laptop.processor.max_frequency }} ГГц</td>
            </tr>
            <tr>
              <td>Количество ядер</td>
              <td>{{ laptop.processor.cores }}</td>
            </tr>
            <tr>
              <td>Количество потоков</td>
              <td>{{ laptop.processor.threads }}</td>
            </tr>
            <tr>
              <td>Кэш</td>
              <td>{{ laptop.processor.cache }} МБ</td>
            </tr>
            <tr>
              <td>Встроенная видеокарта</td>
              <td>{{ laptop.processor.integrated_graphics }}</td>
            </tr>
            <tr>
              <td>Оценка PassMark</td>
              <td>{{ laptop.processor.passmark_score }} (чем выше, тем лучше)</td>
            </tr>
            </tbody>
            <thead>
            <tr>
              <th colspan="2"><abbr title="Position">Оперативная память (ОЗУ)</abbr></th>
              <th><abbr title="Position"></abbr></th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>Объем оперативной памяти</td>
              <td>{{ laptop.ram }} ГБ</td>
            </tr>
            <tr>
              <td>Поколение</td>
              <td>{{ laptop.ram_type.generation }}</td>
            </tr>
            </tbody>
            <thead>
            <tr>
              <th colspan="2"><abbr title="Position">Хранилище</abbr></th>
              <th><abbr title="Position"></abbr></th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>Объем основного диска</td>
              <td>{{ laptop.main_storage }} ГБ</td>
            </tr>
            <tr>
              <td>Тип основного диска</td>
              <td>{{ laptop.main_storage_type.name }}</td>
            </tr>
            <tr v-if="laptop.secondary_storage !== null">
              <td>Объем вторичного диска</td>
              <td>{{ laptop.secondary_storage }} ГБ</td>
            </tr>
            <tr v-if="laptop.secondary_storage_type !== null">
              <td>Тип вторичного диска</td>
              <td>{{ laptop.secondary_storage_type.name }}</td>
            </tr>
            </tbody>
            <thead>
            <tr>
              <th colspan="2"><abbr title="Position">Видеокарта</abbr></th>
              <th><abbr title="Position"></abbr></th>
            </tr>
            </thead>
            <tbody v-if="laptop.graphics_card">
            <tr>
              <td>Марка</td>
              <td>{{ laptop.graphics_card.brand.name }}</td>
            </tr>
            <tr>
              <td>Модель</td>
              <td>{{ laptop.graphics_card.name }}</td>
            </tr>
            <tr>
              <td>Тип видеопамяти</td>
              <td>{{ laptop.graphics_card.memory_interface }}</td>
            </tr>
            <tr>
              <td>Разрядность шины</td>
              <td>{{ laptop.graphics_card.memory_interface_width }}-бит</td>
            </tr>
            <tr>
              <td>Объем видеопамяти</td>
              <td>{{ laptop.graphics_card_memory }} ГБ</td>
            </tr>
            <tr>
              <td>Встроенная видеокарта</td>
              <td>{{ laptop.processor.integrated_graphics }}</td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr>
              <td>Тип</td>
              <td>Встроенная</td>
            </tr>
            <tr>
              <td>Модель</td>
              <td>{{ laptop.processor.integrated_graphics }}</td>
            </tr>
            </tbody>
            <thead>
            <tr>
              <th colspan="2"><abbr title="Position">Аудио</abbr></th>
              <th><abbr title="Position"></abbr></th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>Аудио</td>
              <td>{{ laptop.audio.name }}</td>
            </tr>
            </tbody>
          </table>
          <button class="button is-success is-large has-text-weight-semibold"
                  @click="isOrderModalActive = true" v-if="!showForm && !ordered">
            Заказать
          </button>
        </div>
      </section>
      <section>
        <div class="container" v-if="related_count>0">
          <h2 class="title has-text-centered">Похожие {{ laptop.laptop_type.name }}
            <span v-if="laptop.laptop_type.id === 6"> ноутбуки</span>
            <span v-else-if="laptop.laptop_type.id === 4"> ноутбуки</span>
            <span v-else></span>
          </h2>
          <carousel
              :perPage=2
              :navigationEnabled="true"
              navigationNextLabel="Следующие"
              navigationPrevLabel="Предыдущие"
              paginationActiveColor="#000000"
              paginationColor="#ffdd57"
              :paginationPadding="5"
              :paginationSize="10"
          >
            <slide v-for="(laptop, key) in relatedLaptops" :key="key" class="has-text-centered">
              <ProductCard :laptop="laptop" :dollar="dollar_rate"/>
            </slide>
          </carousel>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import TopBar from '../../components/header/TopBar'
import Header from "../../components/header/HeaderBF";
import axios from 'axios'
import Viewer from 'v-viewer/src/component'
import {Carousel, Slide} from 'vue-carousel'
import 'viewerjs/dist/viewer.css'
import {API_URL} from '../../../main.js'
import ProductCard from "../../components/products/ProductCard";

export default {
  name: 'ProductDetails',
  components: {ProductCard, Header, Viewer, Carousel, Slide, TopBar},
  props: ['brand', 'slug', 'id'],
  inject: ['formatPrice', 'toastWarning', 'openLoading', 'closeLoading'],
  data() {
    return {
      personal_data: {
        name: localStorage.getItem('personal_data_name'),
        phone: localStorage.getItem('personal_data_phone')
      },
      contacts: {
        phone_number: '',
        telegram_username: '',
      },
      inventory_count: Number,
      showForm: false,
      ordered: false,
      index: null,
      laptop: {},
      ddr: 3,
      model: '',
      secondary_storage: '',
      relatedLaptops: '',
      related_count: 0,
      dollar_rate: Number,
      isOrderModalActive: false,
      API_URL: process.env.VUE_APP_API_URL,
      MEDIA_URL: process.env.VUE_APP_MEDIA_URL,
      processor_type: '',
    }
  },
  methods: {
    fetchDollarRate() {
      axios.get(this.API_URL + '/dollar')
          .then(response => {
            this.dollar_rate = response.data[0].exchange_rate
          })
    },
    fetchPhoneNumber() {
      axios.get(this.API_URL + '/dollar/phone')
          .then(response => {
            this.contacts.phone_number = response.data[0].phone_number
            this.contacts.telegram_username = response.data[0].telegram_username
          })
    },
    fetchInventory() {
      axios.get(API_URL + '/inventory', {
        params: {
          laptop: this.id
        }
      })
          .then(response => {
            this.inventory_count = response.data[0].quantity
          })
    },
    fetchLaptop() {
      this.openLoading()
      axios.get(API_URL + '/laptops', {
        params: {
          id: this.id,
          slug: this.slug,
          brand__slug: this.brand
        }
      })

          .then(response => {
            this.laptop = response.data.results[0];
            if (this.laptop.processor.cores === 2) {
              this.processor_type = 'двухъядерный'
            } else if (this.laptop.processor.cores === 4) {
              this.processor_type = 'Четырёхъядерный'
            } else if (this.laptop.processor.cores === 6) {
              this.processor_type = 'Шестиядерный'
            } else {
              this.processor_type = ''
            }
            this.fetchDollarRate()
            this.fetchPhoneNumber()
            this.fetchInventory()

            this.closeLoading()
            if (this.laptop === undefined) {
              this.$router.push('/404')
            }
          })
          .then(this.fetchRelatedLaptops)
    },
    fetchRelatedLaptops() {
      axios.get(API_URL + '/laptops?limit=20&quantity=0', {
        params: {
          type: this.laptop.laptop_type.id,
          id_not: this.id
        }
      })
          .then(response => {
            this.relatedLaptops = response.data.results
            this.related_count = response.data.count
          })
    },
    postInquiry() {
      this.openLoading()
      axios.post(API_URL + '/inquiries/create', {
        name: this.personal_data.name,
        phone: '+998' + this.personal_data.phone,
        laptop: this.id,
        source: 'Details Page'
      })
          .then(() => {
            this.closeLoading()
            this.ordered = !this.ordered;
            this.isOrderModalActive = false
            this.toastWarning(
                'Ваша заявка получена! Ждите наш звонок. Спасибо', 'is-top', 'is-success'
            )
          });
      localStorage.setItem('personal_data_name', this.personal_data.name);
      localStorage.setItem('personal_data_phone', this.personal_data.phone)
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.brand = to.params.brand
    this.slug = to.params.slug
    this.id = to.params.id
    this.inventory_count = to.params.inventory_count
    this.fetchLaptop()
    this.fetchInventory()
    next()
  },
  created() {
    this.fetchLaptop()
  }
}
</script>
<style scoped>
.tag {
  margin: 2px;
}

.image {
  width: calc(20% - -85px);
  cursor: pointer;
  margin: 5px;
  display: inline-block;
}

card-footer {
  padding-left: 5px;
}

.test-enter-active, .test-leave-active {
  transition: opacity .8s linear;
}

.test-enter, .test-leave-to /* .test-leave-active below version 2.1.8 */
{
  opacity: 0;
}

.content h1 {
  font-size: 1.25em;
}

.line-through {
  position: relative;
  font-size: 22px;
}

.line-through:before {
  position: absolute;
  content: "";
  left: 0;
  top: 50%;
  right: 0;
  border-top: 1px solid;
  border-color: inherit;
  color: red;

  -webkit-transform: rotate(-4deg);
  -moz-transform: rotate(-4deg);
  -ms-transform: rotate(-4deg);
  -o-transform: rotate(-4deg);
  transform: rotate(-4deg);
}
</style>
